import { useTranslation } from 'react-i18next'
import { useMatch, useNavigate } from 'react-router-dom'
import { cn } from '@/utils'
import { useStoreActions } from '@/stores'

export const Sidebar = () => {
	const { t } = useTranslation()
	const navigate = useNavigate()

	const home = useMatch('/app')
	const upload = useMatch('/link/submit/*')
	const rewardRoot = useMatch('/reward')
	const rewardNested = useMatch('/reward/*')
	const reward = rewardRoot || rewardNested
	const history = useMatch('/history/*')
	const profile = useMatch('/profile/*')

	const menuItems = [
		{
			path: '/app',
			label: t('home'),
			icon: home
				? require('@/assets/icons/home-active.png')
				: require('@/assets/icons/home-inactive.png'),
			active: !!home
		},
		{
			path: '/link/submit',
			label: t('upload'),
			icon: upload
				? require('@/assets/icons/upload-active.png')
				: require('@/assets/icons/upload-inactive.png'),
			active: !!upload
		},
		{
			path: '/reward',
			label: t('reward'),
			icon: reward
				? require('@/assets/icons/reward-active.png')
				: require('@/assets/icons/reward-inactive.png'),
			isReward: true,
			active: !!reward
		},
		{
			path: '/history',
			label: t('history'),
			icon: history
				? require('@/assets/icons/history-active.png')
				: require('@/assets/icons/history-inactive.png'),
			active: !!history
		},
		{
			path: '/profile',
			label: t('profile'),
			icon: profile
				? require('@/assets/icons/profile-active.png')
				: require('@/assets/icons/profile-inactive.png'),
			active: !!profile
		}
	]

	const { loggedOut } = useStoreActions(action => action.auth)

	return (
		<div className="hidden md:flex flex-col w-64 bg-white h-screen sticky top-0 border-r border-gray-100 p-6 z-50">
			<div className="mb-10 flex justify-center cursor-pointer" onClick={() => navigate('/')}>
				<img
					src={`${process.env.PUBLIC_URL}/logo-gaga.png`}
					alt="GAGA"
					className="h-10 w-auto"
				/>
			</div>

			<nav className="flex-1 flex flex-col gap-2">
				{menuItems.map((item, index) => (
					<div
						key={index}
						onClick={() => navigate(item.path)}
						className={cn(
							'flex items-center gap-4 px-4 py-3 rounded-2xl cursor-pointer transition-all duration-200 group',
							item.active
								? 'bg-[#F1F7FE] text-[#1B81DC]'
								: 'text-gray-500 hover:bg-[#F1F7FE] hover:text-[#1B81DC]'
						)}
					>
						<img
							src={item.icon}
							alt={item.label}
							className={cn(
								'h-6 w-6 transition-all',
								item.isReward &&
									(item.active
										? 'opacity-100 [filter:brightness(0)_saturate(100%)_invert(43%)_sepia(85%)_saturate(2194%)_hue-rotate(188deg)_brightness(93%)_contrast(87%)]'
										: 'grayscale brightness-0 opacity-50')
							)}
						/>
						<span className="font-bold text-base">{item.label}</span>
					</div>
				))}
			</nav>

			<div className="mt-auto">
				<div
					className="flex items-center gap-4 px-4 py-3 rounded-2xl cursor-pointer text-gray-500 hover:bg-red-50 hover:text-red-600 transition-all duration-200"
					onClick={() => {
						loggedOut(() => {
							navigate('/login')
						})
					}}
				>
					<img
						src={require('@/assets/icons/menu-password.png')}
						alt="Logout"
						className="h-6 w-6 opacity-60"
					/>
					<span className="font-bold text-base">{t('logout')}</span>
				</div>
			</div>
		</div>
	)
}
